import script from "./DiscoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoCard.vue?vue&type=script&setup=true&lang=js"

import "./DiscoCard.vue?vue&type=style&index=0&id=041e5d77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041e5d77"]])

export default __exports__